import { default as Logo } from '@hamajima/annualpass/assets/logo.svg?react';
import Locale from './Locale.tsx';
import styles from './header.module.css';

const Header: React.FC = () => {
  return (
    <header className={styles.header}>
      <div className={styles.inner}>
        <a href="/" className={styles.logo}>
          <Logo className={styles.logoImg} />
        </a>
        <Locale />
      </div>
    </header>
  );
};

export default Header;
